/* eslint-disable react/jsx-props-no-spreading */
import React, { useCallback, useState } from 'react'
import { bool, func, string } from 'prop-types'

import NumberField from '@groovehq/internal-design-system/lib/components/NumberField/NumberField'
import Checkbox from '@groovehq/internal-design-system/lib/components/Checkbox/Checkbox'
import { styles as mainStyles } from 'components/integrations/ShopifyV2WidgetCard/styles'

import {
  text,
  paragraph,
} from '@groovehq/internal-design-system/lib/styles/elements'

import { moneyString } from 'util/currency'

import { convertFromCents } from '../../order.util'

const RefundAmount = ({
  refundEntity,
  className,
  register,
  currencyCode,
  isCalculating,
  onUserRefundAmountChange,
}) => {
  const [amountField, setAmountField] = useState({
    label: 'Refund amount',
    value: null,
  })

  const handleAmountChange = useCallback(
    e => {
      const rawValue = e.target.value
      const value = rawValue === '' ? null : rawValue
      setAmountField({
        ...amountField,
        value,
      })
      onUserRefundAmountChange(value ? value * 100 : value)
    },
    [amountField, setAmountField, onUserRefundAmountChange]
  )

  const handleBlurNumber = useCallback(
    () => {
      setAmountField({
        ...amountField,
      })
    },
    [amountField]
  )

  return (
    <div className={className}>
      <div className="grui mb-11">
        <NumberField
          label="Refund amount"
          placeholder="0.00"
          min={0}
          max={+convertFromCents(refundEntity.maximumRefundableTotal)}
          tagPosition="left"
          tagContent={currencyCode}
          className="grui mb-3"
          onChange={handleAmountChange}
          onBlur={handleBlurNumber}
          disabled={isCalculating}
          step="any"
          required
          {...amountField}
          value={amountField.value || refundEntity.total / 100}
        />
        <p css={[paragraph.styles.preflight, text.styles.textMediumDark]}>
          <span css={mainStyles.moneyString}>
            {moneyString({
              currencyCode,
              amount: refundEntity.maximumRefundableTotal,
            })}
          </span>{' '}
          available for refund
        </p>
      </div>
      <Checkbox id="sendNotification" {...register('sendNotification')}>
        Send a notification to the customer
      </Checkbox>
    </div>
  )
}

RefundAmount.propTypes = {
  className: string,
  currencyCode: string,
  isCalculating: bool,
  onUserRefundAmountChange: func,
}

RefundAmount.defaultProps = {
  className: undefined,
  currencyCode: '',
  refundTotal: 0,
  isCalculating: false,
  onUserRefundAmountChange() {},
}

export default RefundAmount
